import { useState } from 'react';
import DemoBookingModal from '../../../components/feature/DemoBookingModal';
import ContactModal from '../../../components/feature/ContactModal';

export default function Hero() {
  const [showDemoModal, setShowDemoModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  const handleFreeTrial = () => {
    window.open('http://112.74.46.225:8002/admin/login?register=register', '_blank');
  };

  const handleContactUs = () => {
    setShowContactModal(true);
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 背景图片 */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20technology%20background%20with%20flowing%20gradient%20waves%20in%20teal%20cyan%20and%20blue%20colors%2C%20smooth%20curves%20and%20soft%20lighting%20creating%20elegant%20minimalist%20atmosphere%2C%20professional%20business%20aesthetic%20with%20subtle%20geometric%20patterns%20and%20clean%20design&width=1920&height=1080&seq=hero-bg-tech-001&orientation=landscape"
          alt="Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* 装饰性光效 */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-96 h-96 bg-teal-400/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-[500px] h-[500px] bg-blue-400/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 relative z-10 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* 左侧内容 */}
          <div className="text-center lg:text-left space-y-8 animate-fade-in">
            {/* 标签 */}
            <div className="inline-flex items-center bg-white/95 backdrop-blur-md border border-teal-200/50 text-teal-700 px-6 py-2.5 rounded-full text-base font-bold shadow-lg hover:shadow-xl transition-all hover:scale-105 cursor-default">
              <i className="ri-sparkling-line mr-2 text-lg animate-pulse"></i>
              智能研发费用管理系统
            </div>

            {/* 主标题 */}
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold leading-tight">
              <span className="text-white drop-shadow-lg">让研发费用管理</span>
              <br />
              <span className="bg-gradient-to-r from-teal-400 via-cyan-300 to-blue-400 bg-clip-text text-transparent drop-shadow-2xl">
                更简单高效
              </span>
            </h1>

            {/* 副标题 */}
            <p className="text-lg sm:text-xl text-white/90 leading-relaxed max-w-xl mx-auto lg:mx-0 drop-shadow-md">
              智研云为企业提供一站式研发费用管理解决方案，从数据采集到报表生成，从项目管理到风险预警，助力企业轻松应对研发费用加计扣除和高新技术企业认定
            </p>

            {/* 核心数据 */}
            <div className="grid grid-cols-3 gap-6 py-8">
              <div className="text-center group cursor-pointer bg-white/10 backdrop-blur-md rounded-xl p-5 border border-white/20 hover:bg-white/20 transition-all hover:scale-105">
                <div className="text-4xl sm:text-5xl font-bold text-white mb-2 group-hover:scale-110 transition-transform drop-shadow-lg">
                  10x
                </div>
                <div className="text-sm sm:text-base text-white/80 font-medium">效率提升</div>
              </div>
              <div className="text-center group cursor-pointer bg-white/10 backdrop-blur-md rounded-xl p-5 border border-white/20 hover:bg-white/20 transition-all hover:scale-105">
                <div className="text-4xl sm:text-5xl font-bold text-white mb-2 group-hover:scale-110 transition-transform drop-shadow-lg">
                  70%
                </div>
                <div className="text-sm sm:text-base text-white/80 font-medium">成本节省</div>
              </div>
              <div className="text-center group cursor-pointer bg-white/10 backdrop-blur-md rounded-xl p-5 border border-white/20 hover:bg-white/20 transition-all hover:scale-105">
                <div className="text-4xl sm:text-5xl font-bold text-white mb-2 group-hover:scale-110 transition-transform drop-shadow-lg">
                  100%
                </div>
                <div className="text-sm sm:text-base text-white/80 font-medium">合规保障</div>
              </div>
            </div>

            {/* CTA按钮 */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button
                onClick={handleFreeTrial}
                className="group relative bg-gradient-to-r from-teal-500 via-cyan-500 to-blue-500 text-white px-10 py-5 rounded-xl text-lg font-bold shadow-xl hover:shadow-[0_20px_60px_rgba(20,184,166,0.5)] transition-all cursor-pointer whitespace-nowrap overflow-hidden hover:scale-105"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500 via-teal-500 to-cyan-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                <span className="relative flex items-center justify-center">
                  <i className="ri-rocket-line mr-2 text-2xl group-hover:rotate-45 transition-transform duration-500"></i>
                  免费试用
                </span>
              </button>
              <button
                onClick={handleContactUs}
                className="group bg-white/95 backdrop-blur-md text-gray-900 px-10 py-5 rounded-xl text-lg font-bold border-2 border-white/50 hover:border-teal-400 hover:bg-white transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl hover:scale-105"
              >
                <span className="flex items-center justify-center">
                  <i className="ri-customer-service-line mr-2 text-2xl group-hover:scale-110 transition-transform"></i>
                  联系我们
                </span>
              </button>
            </div>

            {/* 信任标识 */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 pt-4 text-sm">
              <div className="flex items-center bg-white/10 backdrop-blur-md px-4 py-2 rounded-full border border-white/20">
                <i className="ri-gift-line text-teal-300 text-lg mr-2"></i>
                <span className="font-medium text-white/90 text-sm">免费试用</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-md px-4 py-2 rounded-full border border-white/20">
                <i className="ri-rocket-line text-teal-300 text-lg mr-2"></i>
                <span className="font-medium text-white/90 text-sm">即刻开通使用</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-md px-4 py-2 rounded-full border border-white/20">
                <i className="ri-customer-service-line text-teal-300 text-lg mr-2"></i>
                <span className="font-medium text-white/90 text-sm">专属客服支持</span>
              </div>
            </div>
          </div>

          {/* 右侧图片 */}
          <div className="relative lg:block animate-fade-in-right">
            <div className="relative">
              {/* 装饰性背景 */}
              <div className="absolute -inset-4 bg-gradient-to-r from-teal-400/30 to-blue-400/30 rounded-2xl blur-2xl animate-pulse"></div>
              
              {/* 主图片容器 */}
              <div className="relative bg-white/95 backdrop-blur-md rounded-2xl shadow-xl p-5 border border-white/20">
                <div className="w-full h-[480px] rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20professional%20business%20dashboard%20interface%20showing%20financial%20data%20analytics%20with%20elegant%20charts%20graphs%20and%20research%20development%20expense%20management%20system%20featuring%20clean%20minimalist%20design%20in%20teal%20cyan%20blue%20color%20scheme%20displayed%20on%20sleek%20computer%20screen%20in%20bright%20contemporary%20office%20with%20soft%20lighting&width=800&height=520&seq=hero-dashboard-002&orientation=landscape"
                    alt="智研云系统界面"
                    className="w-full h-full object-cover object-top shadow-lg"
                  />
                </div>

                {/* 浮动卡片1 */}
                <div className="absolute -left-4 top-20 bg-white/95 backdrop-blur-md rounded-xl shadow-xl p-4 border border-white/30 animate-float">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center shadow-lg">
                      <i className="ri-line-chart-line text-white text-xl"></i>
                    </div>
                    <div>
                      <div className="text-sm text-gray-500 font-medium mb-1">研发投入</div>
                      <div className="text-lg font-bold bg-gradient-to-r from-teal-600 to-teal-700 bg-clip-text text-transparent">¥5.2亿</div>
                    </div>
                  </div>
                </div>

                {/* 浮动卡片2 */}
                <div className="absolute -right-4 bottom-20 bg-white/95 backdrop-blur-md rounded-xl shadow-xl p-4 border border-white/30 animate-float" style={{ animationDelay: '1s' }}>
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center shadow-lg">
                      <i className="ri-checkbox-circle-line text-white text-xl"></i>
                    </div>
                    <div>
                      <div className="text-sm text-gray-500 font-medium mb-1">合规率</div>
                      <div className="text-lg font-bold bg-gradient-to-r from-blue-600 to-blue-700 bg-clip-text text-transparent">100%</div>
                    </div>
                  </div>
                </div>

                {/* 浮动卡片3 */}
                <div className="absolute -left-4 bottom-28 bg-white/95 backdrop-blur-md rounded-xl shadow-xl p-4 border border-white/30 animate-float" style={{ animationDelay: '0.5s' }}>
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-lg flex items-center justify-center shadow-lg">
                      <i className="ri-time-line text-white text-xl"></i>
                    </div>
                    <div>
                      <div className="text-sm text-gray-500 font-medium mb-1">处理速度</div>
                      <div className="text-lg font-bold bg-gradient-to-r from-cyan-600 to-cyan-700 bg-clip-text text-transparent">秒级响应</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 滚动提示 */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-20">
        <div className="w-6 h-10 border-2 border-white/60 rounded-full flex items-start justify-center p-1.5 backdrop-blur-sm bg-white/10">
          <div className="w-1 h-2 bg-white/80 rounded-full animate-scroll"></div>
        </div>
      </div>

      <DemoBookingModal isOpen={showDemoModal} onClose={() => setShowDemoModal(false)} />
      <ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />
    </section>
  );
}
